import React, { useState } from 'react';
import { FiHelpCircle } from 'react-icons/fi';
import { GheInputsTab } from '../../components/gheInputs/GheInputsTab';
import { GheResultsTab } from '../../components/gheResults/GheResultsTab';
import ProjectShell from '../../components/layout/ProjectShell';
import { useAppContext } from '../../providers/AppContext';
import { Button, HelpWindow, Typography, gheHelpTopics } from '../../design-system';
import styles from './GheInputsPage.module.css';

type IconProps = { size?: number; color?: string; style?: React.CSSProperties };
const HelpIcon = FiHelpCircle as React.FC<IconProps>;

const GheInputsPage = () => {
  const [helpOpen, setHelpOpen] = useState(false);
  const { configStates, updateConfigStates } = useAppContext();

  // Re-run the ML vs Analogues results (right pane) once inputs are saved.
  const handleInputsSaved = () => {
    updateConfigStates({ refreshCounter: configStates.refreshCounter + 1 });
  };

  return (
    <ProjectShell>
      <div className={styles.header}>
        <Typography.Heading level={3} style={{ margin: 0 }}>
          ML vs Analogues
        </Typography.Heading>
        <Button variant="secondary" startIcon={<HelpIcon size={14} />} onClick={() => setHelpOpen(true)}>
          Help
        </Button>
      </div>
      <div className={styles.split}>
        <div className={styles.pane}>
          <GheInputsTab hideHeader onSaved={handleInputsSaved} />
        </div>
        <div className={styles.pane}>
          <GheResultsTab embedded />
        </div>
      </div>
      <HelpWindow topics={gheHelpTopics} open={helpOpen} onClose={() => setHelpOpen(false)} />
    </ProjectShell>
  );
};

export default GheInputsPage;
